import React from 'react';
import Flexbox from '@/components/common/Flexbox';
import classNames from 'classnames';
import { FaCheck } from 'react-icons/fa';

const CheckIcon: React.FC<{ checked: boolean; darkMode: boolean; variant?: 'square' | 'circle' }> = ({
  checked,
  darkMode,
  variant = 'circle',
}) => {
  const isSquare = variant === 'square';
  const isCircle = variant === 'circle';

  return (
    <Flexbox align={'center'} justify={'center'} className={classNames('w-6 h-6', 'p-1')}>
      <Flexbox
        align={'center'}
        justify={'center'}
        className={classNames(
          'relative',
          'w-full h-full',
          isSquare ? 'rounded-px' : 'rounded-full',
          darkMode ? ['border-white'] : ['border-gray900'],
          darkMode && checked && ['bg-white'],
          (isCircle || (isSquare && !checked)) && 'border-2',
          isCircle ? 'p-1' : 'p-0.5'
        )}
      >
        {isCircle && (
          <div
            className={classNames(
              'absolute',
              darkMode ? ['w-1 h-1'] : ['w-1.5 h-1.5'],
              'rounded-full',
              darkMode ? ['bg-black'] : ['bg-gray900'],
              {
                'hidden invisible': !checked,
              }
            )}
          />
        )}
        {/*@ts-ignore*/}
        {isSquare && <FaCheck className={classNames('text-black', { invisible: !checked })} />}
      </Flexbox>
    </Flexbox>
  );
};

export default CheckIcon;
